export function sortSelectionByIndex<T extends { index: number | null }>(selections: Array<T>): Array<T> {
    return selections.sort((selectionA, selectionB) =>
        selectionA.index !== null && selectionB.index !== null ? selectionA.index - selectionB.index : 0
    );
}
